import React, { useEffect, useState, useContext } from 'react';
import Select, { components, StylesConfig } from 'react-select';
import { GettextContext } from 'rootReact/context';
import { useDispatch, useSelector } from 'react-redux';
import ModalHeader from '../ModalHeader';
import ModalFooter from '../ModalFooter';
import loader from '../../../../images/loading.svg';
import FaIcon from 'rootReact/components/FaIcon';
import FetchApi from '../../REST';
import { setWifi, updateWifi } from '../../../toolkit/actions';
import { fetchListWifiDevice, fetchPhishingPages, fetchFinalPages } from 'root/assets/webpack/src/js/toolkit/think';
import { useInput } from '../../hook/useValidModal.jsx';
import Tooltip from '../Tooltip';
import { setLinkings } from 'root/assets/webpack/src/js/toolkit/actions';

function WifiAttackModal({ onModalClose, id, copy, statusAttack }) {
    const gettext = useContext(GettextContext);
    const deviceFetch = useSelector((state) => state.wifiDevice.wifiDevice);
    const finalPage = useSelector((state) => state.finalPages.finalPages);
    const phishingPage = useSelector((state) => state.phishingPages.phishingPages);
    const outInfectedUrl = useSelector((state) => state.auth.auth.license.outInfectedUrl);
    const loadDeviceList = useSelector((state) => state.wifiDevice.loading);
    const wifiTargetsList = useSelector((state) => state.wifiTargets.wifiTargets);
    const dispatch = useDispatch();
    const [formError, setFormError] = useState([]);
    const [save, setSave] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checkboxPhishingPage, setcheckboxPhishingPage] = useState(copy || id ? true : false);
    const [checkboxLdap, setCheckboxLdap] = useState(false);
    const [formEmptyError, setFormEmptyError] = useState(false);
    const name = useInput('', { isEmpty: true });
    const [wifiDevice, setWifiDevice] = useState({
        id: null,
        title: '',
    });
    const [wifiFinalPage, setWifiFinalPage] = useState({
        id: null,
        title: '',
    });
    const [wifiPhishingPage, setWifiPhishingPage] = useState({
        id: null,
        title: '',
    });
    const [defaultPhishingPage, setDefaultPhishingPage] = useState(null);
    const [defaultFinalPage, setDefaultFinalPage] = useState(null);
    const [defaultDevice, setDefaultDevice] = useState(null);
    const ldapProfileCount = useSelector((state) => state.auth.auth.targetImport.ldapProfileCount);
    const [checkChange, setCheckChange] = useState(false);
    const [defaultAttaclCheck, setDefaultAttaclCheck] = useState(null);

    useEffect(() => {
        dispatch(fetchFinalPages());
        dispatch(fetchPhishingPages());
    }, []);

    useEffect(() => {
        dispatch(fetchListWifiDevice());
    }, []);

    const device = deviceFetch.filter((item) => item.status === 0);

    const optionsPhishingPage = phishingPage.map((item) => {
        const newItem = {};
        newItem.value = item.id;
        newItem.label = item.title;
        return newItem;
    });

    const optionsFinalPage = finalPage.map((item) => {
        const newItem = {};
        newItem.value = item.id;
        newItem.label = item.title;
        return newItem;
    });
    optionsFinalPage.push({ value: 'outInfectedUrl', label: outInfectedUrl });

    const optionsDevice = device.map((item) => {
        const newItem = {};
        newItem.value = item.id;
        newItem.label = item.name;
        newItem.attack = item.attack;
        return newItem;
    });

    const getValueSelect = (state, options) => {
        state ? options.find((item) => item.value === state) : '';
    };
    const onChangeSelectDevice = (newValue) => {
        setWifiDevice({ id: newValue.value, title: newValue.label });
    };
    const onChangeSelectFinalPage = (newValue) => {
        setWifiFinalPage({ id: newValue.value, title: newValue.label });
    };
    const onChangeSelectPhishingPage = (newValue) => {
        setWifiPhishingPage({ id: newValue.value, title: newValue.label });
    };

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props} className='wifiAttack-modal_drop-select'>
                <svg width='10' height='5' viewBox='0 0 10 5' data-testid='dropdown-indicator'>
                    <path d='M0 0L5 5L10 0H0Z' fill='#333333' />
                </svg>
            </components.DropdownIndicator>
        );
    };

    const dot = (color = 'transparent') => ({
        alignItems: 'center',
        display: 'flex',

        ':before': {
            backgroundColor: color,
            borderRadius: 10,
            content: '" "',
            display: 'block',
            marginRight: 8,
            height: 10,
            width: 10,
        },
    });

    useEffect(() => {
        async function fetchApi() {
            if (copy || id) {
                let response = await FetchApi('/wifi-attacks').get(id);
                if (response && response.isError) {
                    throw response;
                }
                name.onChange(
                    copy
                        ? `${response.name} ${gettext.getString('(копия)')}`
                        : `${gettext.getString(`${response.name}`)}`
                );
                if (response.phishingPage === null) {
                    setcheckboxPhishingPage(false);
                } else {
                    setDefaultPhishingPage(response.phishingPage.id);
                    setcheckboxPhishingPage(true);
                }
                if (response.finalPage !== null) {
                    setDefaultFinalPage(response.finalPage.id);
                }
                setDefaultDevice(response.device.id);
                setCheckboxLdap(response.ldapAuth);
                setDefaultAttaclCheck(response);
                setLoading(false);
            }
        }
        try {
            if (copy || id) {
                setLoading(true);
                fetchApi();
            }
        } catch (e) {
            setLoading(false);
            setFormError(gettext.getString('Что-то пошло не так :-('));
        }
    }, [copy, id]);

    const copyPhishingPage = phishingPage.find((item) => item.id === defaultPhishingPage);
    const copyFinalPage = finalPage.find((item) => item.id === defaultFinalPage);
    const editDevice = device.find((item) => item.id === defaultDevice);

    const bodyCopyAndId = {
        name: name.value,
        device: wifiDevice.id === null ? editDevice : wifiDevice,
        finalPage: wifiFinalPage.id !== null ? wifiFinalPage : copyFinalPage,
        phishingPage: !checkboxPhishingPage ? null : wifiPhishingPage.id !== null ? wifiPhishingPage : copyPhishingPage,
        ldapAuth: checkboxLdap,
    };

    //следит за изменениями, если их не было, то при закрытии нет окна подтверждения
    useEffect(() => {
        if (id) {
            if ((bodyCopyAndId.name === defaultAttaclCheck?.name) &&
                wifiDevice.id === null &&
                wifiFinalPage.id === null &&
                wifiPhishingPage.id === null &&
                bodyCopyAndId.ldapAuth === defaultAttaclCheck?.ldapAuth
            ) {
                setCheckChange(false);
            } else {
                setCheckChange(true);
            }
        }
    }, [id, bodyCopyAndId, wifiDevice, wifiFinalPage, wifiPhishingPage, defaultAttaclCheck]);


    const saveSettings = async () => {
        if (!name.value.length || (!id && wifiDevice.id === null)) {
            setFormEmptyError(true);
            return;
        }
        try {
            setSave(true);
            setFormError('');
            if (copy) {
                const response = await FetchApi('/wifi-attacks').post({
                    body: bodyCopyAndId,
                });
                if (response && response.isError) {
                    throw response;
                }
                dispatch(setWifi(response));
            } else if (id) {
                const response = await FetchApi('/wifi-attacks').put(id, {
                    body: bodyCopyAndId,
                });
                if (response && response.isError) {
                    throw response;
                }
                dispatch(updateWifi(response));
            } else {
                const response = await FetchApi('/wifi-attacks').post({
                    body: {
                        name: name.value,
                        device: wifiDevice,
                        finalPage: wifiFinalPage,
                        phishingPage: wifiPhishingPage,
                        ldapAuth: checkboxLdap,
                    },
                });
                if (response && response.isError) {
                    throw response;
                }
                dispatch(setWifi(response));
            }
            setSave(false);
            onModalClose();
        } catch (e) {
            setSave(false);
            const error = e.err.map((item) => {
                const arr = [];
                arr.push(item.message);
                return arr;
            });
            setFormError(error.join(' '));
        }
    };

    const indexSelectPhishingPage = optionsPhishingPage.findIndex((item) => item.value === defaultPhishingPage);
    const indexSelectFinalPage = optionsFinalPage.findIndex((item) => item.value === defaultFinalPage);
    const indexDefaultFinalPage = optionsFinalPage.findIndex((item) => item.value === 'outInfectedUrl');
    const indexDefaultDevice = optionsDevice.findIndex((item) => item.value === defaultDevice);

    const closeModalPopup = () => {
        if (
            copy ||
            (!id && name.value.length) ||
            (!id && wifiDevice.id !== null) ||
            (id && statusAttack !== 1 && wifiTargetsList.length === 0)
        ) {
            const value = confirm(gettext.getString('Отменить изменения'));
            if (value) {
                onModalClose();
            }
        } else {
            onModalClose();
        }
    };

    return (
        <>
            <ModalHeader
                styleText={{ color: '#000', fontWeight: '600', fontSize: '20px' }}
                stylePadding={{
                    paddig: '0',
                    paddigTop: '20px',
                    paddigLeft: '20px',
                    paddigRight: '20px',
                    borderBottom: 'none',
                }}
                title={name.value.length ? name.value : gettext.getString('Новая атака через беспроводные устройства')}
                closeModal={closeModalPopup}
                disabled={save || loading ? true : false}
            />
            {loading || loadDeviceList ? (
                <img className='modal-loader' src={loader} />
            ) : (
                <div className='wifiAttack-modal' data-testid='wifi-attackModal'>
                    <div className='wifiAttack-modal_block-top' data-testid='wifiAttack-modal_block'>
                        <label
                            className={
                                (name.isDirty && name.isEmpty) || (formEmptyError && !name.value.length)
                                    ? 'wifiAttack-modal_label text-error'
                                    : 'wifiAttack-modal_label'
                            }
                            htmlFor='name'
                            data-testid='wifiAttack-modal_label'
                        >
                            {gettext.getString('Название')}
                        </label>
                        <input
                            onChange={(e) => name.onChange(e.target.value)}
                            onBlur={(e) => name.onBlur(e)}
                            value={name.value}
                            id='name'
                            type='text'
                            className={
                                (name.isDirty && name.isEmpty) || (formEmptyError && !name.value.length)
                                    ? 'wifiAttack-modal_input input-error'
                                    : 'wifiAttack-modal_input'
                            }
                            data-testid='wifi-attackInputName'
                            disabled={
                                !copy && ((id && wifiTargetsList.length !== 0) || (id && statusAttack === 1))
                                    ? true
                                    : false
                            }
                        />
                    </div>
                    <div className='wifiAttack-modal_block' data-testid='wifiAttack-modal_block'>
                        <label
                            className={
                                formEmptyError && !id && wifiDevice.id === null
                                    ? 'wifiAttack-modal_label text-error'
                                    : 'wifiAttack-modal_label'
                            }
                            data-testid='wifiAttack-modal_label'
                        >
                            {gettext.getString('Беспроводное устройство')}
                        </label>
                        <Select
                            classNamePrefix={'wifiAttack-modal_select'}
                            onChange={onChangeSelectDevice}
                            value={getValueSelect(wifiDevice, optionsDevice)}
                            options={optionsDevice}
                            isSearchable={false}
                            placeholder={gettext.getString('Устройство')}
                            components={{ DropdownIndicator }}
                            data-testid='wifi-attackInputDevice'
                            defaultValue={optionsDevice[indexDefaultDevice]}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor:
                                        formEmptyError && !id && wifiDevice.id === null ? '#a94442' : '#cbcccb',
                                }),
                                option: (styles, { data }) => ({
                                    ...styles,
                                    ...dot(data.attack !== null ? '#F44336' : '#66BB6A'),
                                }),
                                singleValue: (styles, { data }) => ({
                                    ...styles,
                                    ...dot(data.attack !== null ? '#F44336' : '#66BB6A'),
                                }),
                            }}
                            isDisabled={
                                !copy && ((id && wifiTargetsList.length !== 0) || (id && statusAttack === 1))
                                    ? true
                                    : false
                            }
                        />
                    </div>
                    <div className='wifiAttack-modal_block' data-testid='wifiAttack-modal_block'>
                        <input
                            checked={checkboxPhishingPage}
                            onChange={() => setcheckboxPhishingPage((prev) => !prev)}
                            className='checkbox-modal-phishingPage'
                            type='checkbox'
                            data-testid='wifi-attackCheckboxPhishingPage'
                            disabled={!copy && ((id && wifiTargetsList.length !== 0) || (id && statusAttack === 1)) ? true : false}
                            disabled={!copy && ((id && wifiTargetsList.length !== 0) || (id && statusAttack === 1)) ? true : false}
                        />
                        <label className='wifiAttack-modal_label-phishingPage' data-testid='wifiAttack-modal_label'>
                            {gettext.getString('Фишинговая страница')}
                        </label>
                        <Select
                            classNamePrefix='wifiAttack-modal_select'
                            onChange={onChangeSelectPhishingPage}
                            value={getValueSelect(wifiPhishingPage, optionsPhishingPage)}
                            options={optionsPhishingPage}
                            isSearchable={false}
                            placeholder={gettext.getString('Страница')}
                            components={{ DropdownIndicator }}
                            defaultValue={optionsPhishingPage[indexSelectPhishingPage]}
                            isDisabled={!checkboxPhishingPage || (!copy && ((id && wifiTargetsList.length !== 0) || (id && statusAttack === 1))) ? true : false}
                            data-testid='wifi-attackInputPhishingPage'
                        />
                        <a
                            className={checkboxPhishingPage ? 'wifiAttack-modal_link' : 'wifiAttack-modal_link-none'}
                            href={`/page/${wifiPhishingPage.id}`}
                            target='_blank'
                            data-testid='phishingPage-link'
                        >
                            <Tooltip reactTip={gettext.getString('посмотреть')}>
                                <svg
                                    data-testid='wifi-attackPhishingIcon'
                                    className='wifiAttack-modal_final-icon'
                                    width='18'
                                    height='18'
                                    viewBox='0 0 18 18'
                                >
                                    <path d='M9 0C4.0291 0 0 4.0291 0 9C0 13.9709 4.0291 18 9 18C13.9709 18 18 13.9709 18 9C18 4.0291 13.9709 0 9 0ZM16.8242 8.70968H13.3426C13.3107 7.42355 13.0819 6.1949 12.6761 5.07019C13.4599 4.74329 14.1846 4.30839 14.8454 3.79452C16.02 5.11316 16.7545 6.82548 16.8242 8.70968ZM8.6789 16.8225C7.71387 16.0188 6.90445 14.9754 6.31219 13.7636C7.07226 13.5261 7.87761 13.3961 8.70968 13.3694V16.8236C8.69923 16.8236 8.68936 16.823 8.6789 16.8225ZM9.31994 1.17755C10.415 2.08916 11.3086 3.31026 11.9131 4.73458C11.0851 5.01735 10.2054 5.18168 9.28974 5.21071V1.17581C9.30077 1.17639 9.31006 1.17697 9.31994 1.17755ZM10.2873 1.27626C11.8899 1.54277 13.3275 2.29123 14.447 3.37471C13.8391 3.84097 13.1748 4.23581 12.4566 4.53484C11.9282 3.28239 11.1867 2.1751 10.2873 1.27626ZM8.70968 1.17581V5.21071C7.794 5.1811 6.91374 5.01735 6.08632 4.73458C6.69077 3.31026 7.58439 2.08916 8.67948 1.17755C8.68994 1.17697 8.69923 1.17639 8.70968 1.17581ZM5.54284 4.53542C4.82574 4.23639 4.1609 3.84155 3.55297 3.37529C4.67187 2.29181 6.11013 1.54335 7.71271 1.27684C6.81271 2.1751 6.07181 3.28239 5.54284 4.53542ZM5.86742 5.26994C6.76277 5.58058 7.71677 5.76174 8.70968 5.79194V8.70968H5.238C5.26935 7.49381 5.48477 6.33194 5.86742 5.26994ZM8.70968 9.29032V12.7887C7.794 12.8166 6.90852 12.9664 6.07413 13.2352C5.57129 12.0379 5.27458 10.7042 5.238 9.29032H8.70968ZM7.71271 16.7237C6.27677 16.4851 4.97265 15.8597 3.91239 14.9516C4.48432 14.555 5.10271 14.2194 5.76348 13.9645C6.26981 15.0143 6.93232 15.9463 7.71271 16.7237ZM9.29032 16.8242V13.3699C10.1218 13.3966 10.9277 13.5267 11.6878 13.7642C11.095 14.976 10.2861 16.0194 9.3211 16.823C9.31123 16.823 9.30077 16.8236 9.29032 16.8242ZM12.2365 13.9645C12.8967 14.2194 13.5145 14.5556 14.0876 14.9516C13.0274 15.8592 11.7232 16.4851 10.2873 16.7237C11.0677 15.9463 11.7296 15.0143 12.2365 13.9645ZM11.9259 13.2352C11.0909 12.9664 10.2054 12.8166 9.29032 12.7887V9.29032H12.762C12.7254 10.7042 12.4281 12.0379 11.9259 13.2352ZM9.29032 8.70968V5.79194C10.2826 5.76174 11.2366 5.58116 12.1326 5.27052C12.5146 6.33252 12.7301 7.49439 12.762 8.71026H9.29032V8.70968ZM3.15523 3.79452C3.816 4.30839 4.54065 4.74329 5.32394 5.07019C4.91806 6.1949 4.68929 7.42355 4.65735 8.70968H1.17581C1.24548 6.82548 1.98 5.11316 3.15523 3.79452ZM1.17581 9.29032H4.65735C4.69335 10.7739 5.00342 12.175 5.53006 13.4344C4.79439 13.7212 4.10865 14.1033 3.47574 14.5556C2.11239 13.1986 1.25187 11.3435 1.17581 9.29032ZM14.5243 14.555C13.8914 14.1033 13.2056 13.7206 12.4694 13.4338C12.9966 12.1744 13.3061 10.7733 13.3426 9.28974H16.8242C16.7481 11.3435 15.887 13.1986 14.5243 14.555Z' />
                                </svg>
                            </Tooltip>
                        </a>
                    </div>
                    <div className='wifiAttack-modal_block' data-testid='wifiAttack-modal_block'>
                        <label className='wifiAttack-modal_label' data-testid='wifiAttack-modal_label'>
                            {gettext.getString('Финальная переадресация')}
                        </label>
                        <Select
                            classNamePrefix='wifiAttack-modal_select'
                            onChange={onChangeSelectFinalPage}
                            value={getValueSelect(wifiFinalPage, optionsFinalPage)}
                            options={optionsFinalPage}
                            isSearchable={false}
                            components={{ DropdownIndicator }}
                            defaultValue={
                                defaultFinalPage
                                    ? optionsFinalPage[indexSelectFinalPage]
                                    : optionsFinalPage[indexDefaultFinalPage]
                            }
                            data-testid='wifi-attackInputFinalPage'
                            isDisabled={
                                !copy && ((id && wifiTargetsList.length !== 0) || (id && statusAttack === 1))
                                    ? true
                                    : false
                            }
                        />
                        <a
                            className='wifiAttack-modal_link'
                            href={
                                wifiFinalPage.id === null || wifiFinalPage.id === 'outInfectedUrl'
                                    ? `${outInfectedUrl}`
                                    : `/final/${wifiFinalPage.id}`
                            }
                            target='_blank'
                            data-testid='finalPage-link'
                        >
                            <Tooltip reactTip={gettext.getString('посмотреть')}>
                                <svg
                                    data-testid='wifi-attackFinalIcon'
                                    className='wifiAttack-modal_final-icon'
                                    width='18'
                                    height='18'
                                    viewBox='0 0 18 18'
                                >
                                    <path d='M9 0C4.0291 0 0 4.0291 0 9C0 13.9709 4.0291 18 9 18C13.9709 18 18 13.9709 18 9C18 4.0291 13.9709 0 9 0ZM16.8242 8.70968H13.3426C13.3107 7.42355 13.0819 6.1949 12.6761 5.07019C13.4599 4.74329 14.1846 4.30839 14.8454 3.79452C16.02 5.11316 16.7545 6.82548 16.8242 8.70968ZM8.6789 16.8225C7.71387 16.0188 6.90445 14.9754 6.31219 13.7636C7.07226 13.5261 7.87761 13.3961 8.70968 13.3694V16.8236C8.69923 16.8236 8.68936 16.823 8.6789 16.8225ZM9.31994 1.17755C10.415 2.08916 11.3086 3.31026 11.9131 4.73458C11.0851 5.01735 10.2054 5.18168 9.28974 5.21071V1.17581C9.30077 1.17639 9.31006 1.17697 9.31994 1.17755ZM10.2873 1.27626C11.8899 1.54277 13.3275 2.29123 14.447 3.37471C13.8391 3.84097 13.1748 4.23581 12.4566 4.53484C11.9282 3.28239 11.1867 2.1751 10.2873 1.27626ZM8.70968 1.17581V5.21071C7.794 5.1811 6.91374 5.01735 6.08632 4.73458C6.69077 3.31026 7.58439 2.08916 8.67948 1.17755C8.68994 1.17697 8.69923 1.17639 8.70968 1.17581ZM5.54284 4.53542C4.82574 4.23639 4.1609 3.84155 3.55297 3.37529C4.67187 2.29181 6.11013 1.54335 7.71271 1.27684C6.81271 2.1751 6.07181 3.28239 5.54284 4.53542ZM5.86742 5.26994C6.76277 5.58058 7.71677 5.76174 8.70968 5.79194V8.70968H5.238C5.26935 7.49381 5.48477 6.33194 5.86742 5.26994ZM8.70968 9.29032V12.7887C7.794 12.8166 6.90852 12.9664 6.07413 13.2352C5.57129 12.0379 5.27458 10.7042 5.238 9.29032H8.70968ZM7.71271 16.7237C6.27677 16.4851 4.97265 15.8597 3.91239 14.9516C4.48432 14.555 5.10271 14.2194 5.76348 13.9645C6.26981 15.0143 6.93232 15.9463 7.71271 16.7237ZM9.29032 16.8242V13.3699C10.1218 13.3966 10.9277 13.5267 11.6878 13.7642C11.095 14.976 10.2861 16.0194 9.3211 16.823C9.31123 16.823 9.30077 16.8236 9.29032 16.8242ZM12.2365 13.9645C12.8967 14.2194 13.5145 14.5556 14.0876 14.9516C13.0274 15.8592 11.7232 16.4851 10.2873 16.7237C11.0677 15.9463 11.7296 15.0143 12.2365 13.9645ZM11.9259 13.2352C11.0909 12.9664 10.2054 12.8166 9.29032 12.7887V9.29032H12.762C12.7254 10.7042 12.4281 12.0379 11.9259 13.2352ZM9.29032 8.70968V5.79194C10.2826 5.76174 11.2366 5.58116 12.1326 5.27052C12.5146 6.33252 12.7301 7.49439 12.762 8.71026H9.29032V8.70968ZM3.15523 3.79452C3.816 4.30839 4.54065 4.74329 5.32394 5.07019C4.91806 6.1949 4.68929 7.42355 4.65735 8.70968H1.17581C1.24548 6.82548 1.98 5.11316 3.15523 3.79452ZM1.17581 9.29032H4.65735C4.69335 10.7739 5.00342 12.175 5.53006 13.4344C4.79439 13.7212 4.10865 14.1033 3.47574 14.5556C2.11239 13.1986 1.25187 11.3435 1.17581 9.29032ZM14.5243 14.555C13.8914 14.1033 13.2056 13.7206 12.4694 13.4338C12.9966 12.1744 13.3061 10.7733 13.3426 9.28974H16.8242C16.7481 11.3435 15.887 13.1986 14.5243 14.555Z' />
                                </svg>
                            </Tooltip>
                        </a>
                    </div>
                    {ldapProfileCount && (
                        <div className='wifiAttack-modal_block-top' data-testid='wifiAttack-modal_block'>
                            <input
                                checked={checkboxLdap}
                                onChange={() => setCheckboxLdap((prev) => !prev)}
                                className='checkbox-modal-ldap'
                                type='checkbox'
                                data-testid='wifi-attackCheckboxLdap'
                                disabled={
                                    !copy && ((id && wifiTargetsList.length !== 0) || (id && statusAttack === 1))
                                        ? true
                                        : false
                                }
                            />
                            <label className='wifiAttack-modal_label-ldap' data-testid='wifiAttack-modal_label'>
                                {`${gettext.getString('Проверка подлинности LDAP')}`}
                            </label>
                        </div>
                    )}
                </div>
            )}
            <div className='wifiAttack-modal_process'>
                {formError.length !== 0 ? <FaIcon type={'error'} text={formError} /> : ''}
                {save ? <FaIcon type={'pending'} text={gettext.getString('Сохранение...')} /> : ''}
                <ModalFooter
                    styleBtnOk={{ backgroundColor: '#37397F' }}
                    titleBtnOk={gettext.getString('Сохранить')}
                    titleBtnClose={gettext.getString('Отменить')}
                    closeModal={closeModalPopup}
                    disabled={
                        loading ||
                            save ||
                            (name.isDirty && name.isEmpty) ||
                            (id && wifiTargetsList.length !== 0 && !copy) ||
                            (id && statusAttack === 1 && !copy)
                            ? true
                            : false
                    }
                    disabledCancel={loading || save ? true : false}
                    onEnter={saveSettings}
                />
            </div>
        </>
    );
}

export default WifiAttackModal;
